import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  fontWeights, fontSizes, lineHeights, breakpoints, palette, borderRadiuses,
}: Theme) => ({
  root: {
    marginTop: '1.5rem',
  },
  rootWithBottomMargin: {
    marginBottom: '1.5rem',
    [breakpoints.up('sm')]: {
      marginBottom: '2.75rem',
    },
  },
  titleBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1.25rem',
    [breakpoints.up('sm')]: {
      marginBottom: '0.75rem',
    },
  },
  title: {
    marginTop: 0,
    marginBottom: 0,
    fontSize: fontSizes.md,
    lineHeight: lineHeights.lg,
    fontWeight: fontWeights.medium,
    [breakpoints.up('sm')]: {
      fontSize: fontSizes.lg,
    },
  },
  titleSmall: {
    marginTop: 0,
    marginBottom: '0.25rem',
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    fontWeight: fontWeights.medium,
    [breakpoints.up('sm')]: {
      marginBottom: '0.5rem',
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
  },
  inlineWrapper: {
    '& p': {
      display: 'inline',
      marginTop: 0,
      marginBottom: 0,
      color: palette.custom.greyNeutral,
      fontSise: fontSizes.xxs,
      lineHeight: 1.5,
      [breakpoints.up('sm')]: {
        marginBottom: '0.5rem',
      },
    },
  },
  paragraphWithMargin: {
    marginTop: 0,
    marginBottom: '0.25rem',
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    [breakpoints.up('sm')]: {
      marginBottom: '0.5rem',
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
  },
  infoLabel: {
    marginTop: '1rem',
    backgroundColor: palette.secondary.light,
    width: '100%',
    maxWidth: '27.875rem',
    height: '3.5rem',
    gap: '0.5rem',
    padding: '0.75rem',
    borderRadius: borderRadiuses.lg,
    alignItems: 'flex-start',
    '& > div': {
      paddingRight: 0,
    },
    '& p': {
      fontSize: fontSizes.xxs,
      lineHeight: lineHeights.xxs,
    },
  },
  linkNoUnderline: {
    color: palette.primary.dark,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));
